import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

const confirmButtonClassNames = {
    danger: 'wave-line-confirm-dialog__btn wave-line-confirm-dialog__btn--danger',
    logout: 'wave-line-confirm-dialog__btn wave-line-confirm-dialog__btn--logout',
    primary: 'wave-line-confirm-dialog__btn wave-line-confirm-dialog__btn--primary',
};

export default function ConfirmDialog({
    open,
    title,
    text,
    confirmButtonText = 'OK',
    cancelButtonText = 'Отмена',
    confirmButtonVariant = 'primary',
    mode = 'confirm',
    onConfirm,
    onCancel,
}) {
    const isAlert = mode === 'alert';
    const confirmClassName = confirmButtonClassNames[confirmButtonVariant]
        ?? confirmButtonClassNames.primary;

    const handleOpenChange = (nextOpen) => {
        if (!nextOpen) {
            onCancel();
        }
    };

    return (
        <AlertDialog.Root open={open} onOpenChange={handleOpenChange}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className="wave-line-confirm-dialog__overlay" />
                <AlertDialog.Content className="wave-line-confirm-dialog">
                    {title ? (
                        <AlertDialog.Title className="wave-line-confirm-dialog__title">
                            {title}
                        </AlertDialog.Title>
                    ) : null}
                    {text ? (
                        <AlertDialog.Description className="wave-line-confirm-dialog__text">
                            {text}
                        </AlertDialog.Description>
                    ) : null}
                    <div className="wave-line-confirm-dialog__actions">
                        {!isAlert ? (
                            <AlertDialog.Cancel asChild>
                                <button
                                    type="button"
                                    className="wave-line-confirm-dialog__btn wave-line-confirm-dialog__btn--cancel"
                                    onClick={onCancel}
                                >
                                    {cancelButtonText}
                                </button>
                            </AlertDialog.Cancel>
                        ) : null}
                        <AlertDialog.Action asChild>
                            <button type="button" className={confirmClassName} onClick={onConfirm}>
                                {confirmButtonText}
                            </button>
                        </AlertDialog.Action>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
}
